import { useContext } from "react";
import Box from "@material-ui/core/Box";
import {
  Button,
  CircularProgress,
  Container,
  Grid,
  Typography,
} from "@material-ui/core";
import { useParams } from "react-router";

import { PersonalInfoStyle } from "../Styles/ProfilePagesStyles";
import AdminHeader from "../SubComponents/AdminHeader";
import Footer from "../SubComponents/Footer";
import AuthContext from "../../store/Auth/AuthContext";
import AlertContext from "../../store/Alert/AlertContext";
import { useVerifyChangeEmailMutation } from "../../services/react-query/profile-settings";
import ProjectPoolHeading from "../Projects/ProjectPoolHeading";
import { CountdownCircleTimer } from "react-countdown-circle-timer";

const ChangeEmailConfirmation = () => {
  const { token } = useParams() as any;
  const classes = PersonalInfoStyle();
  const { Logout } = useContext<any>(AuthContext);
  const { setAlert } = useContext<any>(AlertContext);

  const mutation = useVerifyChangeEmailMutation({
    onSuccess: (data: any) => {
      setAlert(data?.message, "success");
    },
    onError: (data: any) => {
      setAlert(data?.message, "warning");
    },
  });

  const confirmSubmit = () => {
    mutation.mutate({ token });
  };

  const logout = () => {
    Logout("session");
  };

  return (
    <>
      <AdminHeader />
      <Box className={classes.profilesetting} component="section">
        <Container fixed>
          <Grid>
            {!mutation.isSuccess && (
              <Grid item md={12}>
                <Box p={0}>
                  <ProjectPoolHeading title1="Confirm Change " title2="Email" />
                </Box>
                <Box
                  display="flex"
                  flexDirection="column"
                  style={{ gap: "1rem" }}
                  pb={4}
                >
                  <Typography>
                    You are about to change the email address associated with
                    your account. Once you proceed, the email you previously
                    entered will replace the current one as your main contact
                    address.
                  </Typography>
                  <Typography>
                    <span style={{ fontWeight: "bold" }}>NOTE:</span> After
                    confirming this change, you will be required to sign in
                    again using your new email.
                  </Typography>
                  <Typography>
                    If you're ready to proceed, click{" "}
                    <span style={{ fontWeight: "bold" }}>Confirm</span> to
                    finalize the change.
                  </Typography>
                </Box>
                <Button
                  variant="contained"
                  color="secondary"
                  size="large"
                  disabled={mutation.isPending}
                  onClick={confirmSubmit}
                >
                  CONFIRM {mutation.isPending && <CircularProgress />}
                </Button>
              </Grid>
            )}
            {mutation.isSuccess && (
              <Grid item md={12}>
                <Box p={0}>
                  <ProjectPoolHeading
                    title1="Email Changed "
                    title2="Successfully"
                  />
                </Box>
                <Box
                  pb={2}
                  display="flex"
                  alignItems="center"
                  style={{ gap: "1rem" }}
                >
                  <Typography>
                    You will be redirected to the sign in.
                  </Typography>
                  <CountdownCircleTimer
                    isPlaying
                    duration={5}
                    colors="#3eb8aa"
                    size={30}
                    isGrowing
                    strokeWidth={5}
                    rotation="counterclockwise"
                    onComplete={logout}
                  >
                    {({ remainingTime }) => {
                      return (
                        <Typography color="primary">{remainingTime}</Typography>
                      );
                    }}
                  </CountdownCircleTimer>
                </Box>

                <Button
                  variant="contained"
                  color="secondary"
                  size="large"
                  disabled={mutation.isPending}
                  onClick={logout}
                >
                  SIGN IN NOW
                </Button>
              </Grid>
            )}
          </Grid>
        </Container>
      </Box>
      <Footer />
    </>
  );
};
export default ChangeEmailConfirmation;
